// The one compact-table look for markdown-derived tables. Shared by the chat transcript
// renderer (message-markdown.tsx) and the evidence excerpt renderer (LAT-951) so the same
// source table cannot render two different ways depending on where it is quoted. Margins
// are contextual and stay at the call sites.

export const markdownTableWrapperClasses = "max-w-full overflow-x-auto";

/** Chat transcript tables: natural column widths, the wrapper scrolls horizontally. */
export const markdownTableClasses = "w-full min-w-max border-collapse text-left text-xs";

/**
 * Evidence excerpt tables: `min-w-max` keeps the quoted table in the shape it has in the
 * document rather than rewrapping its cells into something the reader would have to
 * reconstruct. It is the quote's own layout, so the box around it scrolls in both
 * directions instead.
 */
export const evidenceTableClasses = "w-max min-w-full border-collapse text-left text-xs";

export const markdownTableHeadClasses = "bg-muted";

export const markdownTableHeaderCellClasses =
  "border border-border px-2 py-1.5 align-top font-semibold text-foreground";

export const markdownTableCellClasses =
  "border border-border px-2 py-1.5 align-top text-foreground";
